<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">

<mat-dialog-content>

<div>
  <mat-form-field appearance="outline" style="width: 99%;">
    <mat-label>Ingest Folder Path</mat-label>
    <input matInput [(ngModel)]="ingestParquetPartitionFolderPath" (paste)="onPathPaste($event)" (focus)="focusCycle = 'input'" (keydown.enter)="onRefreshIngestParquetPartitionFoldersList()" #pathInput>
  </mat-form-field>
</div>
<div style="display: flex; align-items: center; margin-bottom: 10px;">
  <h2 mat-dialog-title cdkDragHandle style="margin: 0; padding: 0; flex: 1;">Browse for a Partition Folder to ingest</h2>
  <button mat-icon-button color="primary" (click)="onRefreshIngestParquetPartitionFoldersList()" tabindex="-1" [class.focused-btn]="focusCycle === 'refresh'" #refreshBtn>
    <mat-icon style="font-size: 30px; width: 27px; height: 27px;">refresh</mat-icon>
  </button>
  <button mat-icon-button (click)="onHomeClicked()" tabindex="-1" style="margin-left: 8px;" [class.focused-btn]="focusCycle === 'home'" #homeBtn>
    <mat-icon style="font-size: 30px; width: 27px; height: 27px;">home</mat-icon>
  </button>
</div>
    <div class="center" *ngIf="isLoading | async">
        <mat-spinner></mat-spinner>
    </div>
    <div #fileList tabindex="0" style="outline: none;">
    <cdk-virtual-scroll-viewport *ngIf="dataSource" itemSize="48" style="border: solid 1px #303030; min-height: 400px; height: auto;">
        <ng-container *cdkVirtualFor="let item of files"></ng-container>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding [attr.aria-expanded]="true">
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <mat-icon class="mat-icon-rtl-mirror">text_snippet</mat-icon>
                <button mat-button [class.selected-file]="selectedNode === node" [class.focused-file]="isFocusedNode(node)" (click)="onNodeSingleClick(node)" (dblclick)="onFileSelected(node)">{{node.filename}}</button>
            </mat-tree-node>

            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" [attr.aria-expanded]="true" >
                    <mat-icon class="mat-icon-rtl-mirror">{{treeControl.isExpanded(node) ? 'expand_more' :
                        'chevron_right'}}</mat-icon>
                </button>
                <mat-icon class="mat-icon-rtl-mirror" class="yellow-icon" style="margin-right: 15px;">
                    {{treeControl.isExpanded(node) ? 'folder_open' : 'folder'}}</mat-icon>
                <span style="cursor: pointer;" [class.selected-file]="selectedNode === node" [class.focused-file]="isFocusedNode(node)" (click)="onNodeSingleClick(node)" (dblclick)="onFileSelected(node)">{{node.filename}}</span>
            </mat-tree-node>
        </mat-tree>
    </cdk-virtual-scroll-viewport>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="display: flex; align-items: center;">
    <div style="flex: 1; display: flex; justify-content: center; gap: 8px;">
      <button mat-raised-button color="primary" (click)="onIngestFilePathSubmit()" tabindex="-1" [class.focused-action-btn]="focusCycle === 'open'" #openBtn>OPEN</button>
      <button mat-raised-button mat-dialog-close tabindex="-1" [class.focused-action-btn]="focusCycle === 'cancel'" #cancelBtn>CANCEL</button>
    </div>
    <!-- <mat-form-field *ngIf="supportedFileTypes.length > 0" class="compact-ui" style="width: 140px; margin-left: auto;">
      <mat-label>File(s) of type:</mat-label>
      <mat-select style="width: 100%;" [(value)]="fileType" (selectionChange)="onFilterChanged($event)">
        <mat-option [value]="fileType" *ngFor="let fileType of supportedFileTypes">{{fileType}}</mat-option>
      </mat-select>
    </mat-form-field> -->
</mat-dialog-actions>
</div>